export default __webpack_public_path__ + "static/media/chevron-down.0f96544c.svg";